import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  resetRestartMsgServerState,
  restartMessagingServer,
} from "../redux/otherActions/restartMsgServerSlice";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../components/common/confirmDialog";
import useBranchGuard from "../hooks/useBranchGuard";
import { humanizeError } from "../utils/errorText";

const RestartMessagingServer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const branchUrl = useParams().id;
  useBranchGuard();

  const { loading, success, error } = useSelector(
    (state) => state.restartMsgServer.restartMesgServer
  );
  const [isOpen, setIsOpen] = useState(false);

  const handleMsgServer = () => {
    setIsOpen(false);
    dispatch(restartMessagingServer({ branchUrl }));
  };

  useEffect(() => {
    if (success) {
      toast.success(t("actions.restartMsg"), { position: "top-right" });
      dispatch(resetRestartMsgServerState());
    } else if (error) {
      toast.error(humanizeError(error, t), { position: "top-right" });
      dispatch(resetRestartMsgServerState());
    }
  }, [dispatch, success, error, t]);

  return (
    <div className="mb-4">
      <ConfirmDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirm={handleMsgServer}
        title={t("actions.serverCon")}
        warning={t("actions.serverMsg")}
        confirmText={t("actions.restart")}
        danger
      />

      <div className="w-full text-left">
        <h2 className="px-6 py-1 font-medium text-base sm:text-lg bg-[--gr-4] text-slate-300">
          {t("nav.server")}
        </h2>
        <div className="gap-1 sm:gap-2 flex flex-col mt-2 text-sm sm:text-base">
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            disabled={loading}
            className="w-full text-left px-6 py-4 font-medium bg-[--primary] hover:bg-[--primary-hover] rounded-sm text-white disabled:opacity-50"
          >
            {t("actions.restart")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestartMessagingServer;
